/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['skins.core.FacebookCommentSkin'] = {
  "react": [
    [
      "div",
      "fb-root",
      [],
      {}
    ],
    [
      "div",
      "facebook",
      [],
      {}
    ],
    [
      "div",
      "facebookPreviewBlocker",
      [],
      {}
    ]
  ],
  "params": {
    "tdr": "URL"
  },
  "paramsDefaults": {
    "tdr": "BASE_THEME_DIRECTORY"
  },
  "css": {
    "%fb-root": "display:none;",
    "%[data-state~=\"dark\"]": "background:url([tdr]dark-facebook-comments.png) no-repeat;",
    "%[data-state~=\"light\"]": "background:url([tdr]bright-facebook-comments.png) no-repeat;",
    "%[data-state~=\"mobileView\"][data-state~=\"dark\"]": "background:url([tdr]mobile-dark-facebook-comments.jpg) no-repeat;",
    "%[data-state~=\"mobileView\"][data-state~=\"light\"]": "background:url([tdr]mobile-bright-facebook-comments.jpg) no-repeat;",
    "%[data-state~=\"disabled\"]": "pointer-events:none;"
  }
}

    return skins;
});
